module.exports = __webpack_public_path__ + "static/media/thank_you_screen_image.96dcf8b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/viaVan/images/thank_you_screen_image.svg
// module id = 517
// module chunks = 0